app.directive('lightNgClick', function() {
	return {
		restrict: 'A',
		scope: {
			"lightNgClick": "&"
		},
		link: function(scope, element, attrs){
			if(typeof(scope.lightNgClick) == 'function') {
				element.bind('click', function(){
					scope.lightNgClick();
					scope.$evalAsync();
				});
			}
		}
	};
});